import { DatePicker } from 'element-ui'
import i18n from '../i18n';

const mixinDatePicker = {
  components: {
    [DatePicker.name]: DatePicker,
  },

  computed: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: i18n.t('common_words.today'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.yesterday'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.last_7_days'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.this_week'),
            onClick(picker) {
              const current = new Date;
              const start = new Date(current.setDate(current.getDate() - current.getDay()));
              const end = new Date(current.setDate(current.getDate() - current.getDay() + 6));
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.last_week'),
            onClick(picker) {
              const current = new Date;
              const start = new Date(current.setDate(current.getDate() - current.getDay() - 7));
              const end = new Date(current.setDate(current.getDate() - current.getDay() + 6));
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.this_month'),
            onClick(picker) {
              const current = new Date();
              const start = new Date(current.getFullYear(), current.getMonth(), 1);
              const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: i18n.t('common_words.last_month'),
            onClick(picker) {
              const current = new Date();
              const start = new Date(current.getFullYear(), current.getMonth() - 1, 1);
              const end = new Date(current.getFullYear(), current.getMonth(), 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.this_createdquarter'),
            onClick(picker) {
              const quarters = {
                1: [0, 1, 2],
                2: [3, 4, 5],
                3: [6, 7, 8],
                4: [9, 10, 11],
              }
              let quarter = null;
              const current = new Date();
              for (const element in quarters) {
                for (let index = 0; index < quarters[element].length; index++) {
                  if (quarters[element][index] == current.getMonth()) {
                    quarter = element
                    break
                  }
                }
                if (quarter) break
              }
              const start = new Date(current.getFullYear(), quarters[quarter][0], 1);
              const end = new Date(current.getFullYear(), quarters[quarter][2] + 1, 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.last_quarter'),
            onClick(picker) {
              const quarters = {
                1: [0, 1, 2],
                2: [3, 4, 5],
                3: [6, 7, 8],
                4: [9, 10, 11],
              }
              let quarter = null;
              const current = new Date();
              for (var element in quarters) {
                for (let index = 0; index < quarters[element].length; index++) {
                  if (quarters[element][index] == current.getMonth()) {
                    if (element == 1) quarter = 4
                    else quarter = (element - 1)
                    break
                  }
                }
                if (quarter) break
              }
              var start, end
              if (quarter == 4) {
                start = new Date((current.getFullYear() - 1), quarters[quarter][0], 1);
                end = new Date((current.getFullYear() - 1), quarters[quarter][2] + 1, 0);
              } else {
                start = new Date(current.getFullYear(), quarters[quarter][0], 1);
                end = new Date(current.getFullYear(), quarters[quarter][2] + 1, 0);
              }
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.this_semester'),
            onClick(picker) {
              const semesters = {
                1: [0, 1, 2, 3, 4, 5],
                2: [6, 7, 8, 9, 10, 11],
              }
              let semester = null;
              const current = new Date();
              for (const element in semesters) {
                for (let index = 0; index < semesters[element].length; index++) {
                  if (semesters[element][index] == current.getMonth()) {
                    semester = element
                    break
                  }
                }
                if (semester) break
              }
              const start = new Date(current.getFullYear(), semesters[semester][0], 1);
              const end = new Date(current.getFullYear(), semesters[semester][5] + 1, 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.last_semester'),
            onClick(picker) {
              const semesters = {
                1: [0, 1, 2, 3, 4, 5],
                2: [6, 7, 8, 9, 10, 11],
              }
              let semester = null;
              const current = new Date();
              for (var element in semesters) {
                for (let index = 0; index < semesters[element].length; index++) {
                  if (semesters[element][index] == current.getMonth()) {
                    if (element == 1) semester = 2
                    else semester = 1
                    break
                  }
                }
                if (semester) break
              }
              var start, end
              if (semester == 2) {
                start = new Date((current.getFullYear() - 1), semesters[semester][0], 1);
                end = new Date((current.getFullYear() - 1), semesters[semester][5] + 1, 0);
              } else {
                start = new Date(current.getFullYear(), semesters[semester][0], 1);
                end = new Date(current.getFullYear(), semesters[semester][5] + 1, 0);
              }
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.this_year'),
            onClick(picker) {
              const current = new Date();
              const start = new Date(current.getFullYear(), 0, 1);
              const end = new Date(current.getFullYear(), 11 + 1, 0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: i18n.t('common_words.last_year'),
            onClick(picker) {
              const current = new Date();
              const start = new Date((current.getFullYear() - 1), 0, 1);
              const end = new Date((current.getFullYear() - 1), 11 + 1, 0);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    }
  },

  data() {
    return {
      rangeDate: [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11 + 1, 0)],
    }
  },
}

export default mixinDatePicker
